import { Entity } from '@backstage/catalog-model'

import { InvalidCodeCoverageAnnotationError, readCoverageQuery } from './CodeCoverageCard/coverageAnnotations'

export const isCodeCoverageAvailable = (entity: Entity): boolean => {
  try {
    readCoverageQuery(entity)
    return true
  } catch (error) {
    if (error instanceof InvalidCodeCoverageAnnotationError) return false
    throw error
  }
}
